import type {Comment} from '../constants/ReportBuilderInterfce';

import {getCommentUserId, type RawComment} from './commentUtils';

/** Any collaborator with a user id can resolve/reopen threads (Google Docs style). */
export const canResolveComment = (
  _comment: RawComment | Comment,
  activeUserId: string | undefined
): boolean => Boolean(activeUserId);

/** Only the comment author may edit their comment. */
export const canEditComment = (
  comment: RawComment | Comment,
  activeUserId: string | undefined
): boolean => {
  if (!activeUserId) return false;

  return getCommentUserId(comment as RawComment) === activeUserId;
};

/** Author may delete own comment; root thread delete still handled by caller. */
export const canDeleteComment = (
  comment: RawComment | Comment,
  activeUserId: string | undefined
): boolean => canEditComment(comment, activeUserId);
